import { combineReducers } from '@reduxjs/toolkit';
import { filtersDataMyTasks } from '../store/filtersData/filtersData';
import { formAdd5SCard } from '../store/formAdd5SCard/formAdd5SCard';
import { mainTable5S } from '../store/mainTable5S/mainTable5S';
import { inconsistency5SFiles } from '../store/inconsistency5SFiles/inconsistency5SFiles';
import { report5SAudits } from '../store/report5SAudits/report5SAudits';
import { reportDone5SAudit } from '../store/reportDone5SAudit/reportDone5SAudit';

export const rootMyTasks = combineReducers({
  filtersData: filtersDataMyTasks,
  formAdd5SCard: formAdd5SCard,
  mainTable5S: mainTable5S,
  inconsistency5SFiles: inconsistency5SFiles,
  report5SAudits: report5SAudits,
  reportDone5SAudit: reportDone5SAudit,
});
